import type {
  SlideLibraryCollection,
  SlideLibraryCollectionKind,
  SlideLibrarySlide,
} from "./types";

export function isPreslinkCollection(
  collection: Pick<SlideLibraryCollection, "kind"> | null | undefined
): boolean {
  return collection?.kind === "preslink_template";
}

export function isVisibleCompanyCollection(
  collection: Pick<SlideLibraryCollection, "kind" | "source" | "readOnly">,
  preslinkEnabled: boolean
): boolean {
  if (collection.source !== "company" && !collection.readOnly) {
    return true;
  }
  if (collection.kind === "standard") {
    return true;
  }
  return collection.kind === "preslink_template" && preslinkEnabled;
}

export function isInsertableLibrarySlide(slide: SlideLibrarySlide): boolean {
  if (slide.collectionKind === "preslink_template") return false;
  if (slide.source !== "company") return true;
  return slide.collectionKind === "standard";
}

export function isPreviewOnlyLibrarySlide(slide: SlideLibrarySlide): boolean {
  return slide.collectionKind === "preslink_template";
}

export function filterVisibleCollections(
  collections: SlideLibraryCollection[],
  preslinkEnabled: boolean
): SlideLibraryCollection[] {
  return collections.filter((collection) =>
    isVisibleCompanyCollection(collection, preslinkEnabled)
  );
}

export function filterInsertableCollections(
  collections: SlideLibraryCollection[]
): SlideLibraryCollection[] {
  return collections.filter(
    (collection) =>
      (collection.source !== "company" && !collection.readOnly) || collection.kind === "standard"
  );
}
